module.exports = "/_next/static/images/macpunks-story-2-61f8017e6ab98b2167f4603562218838.png";